import styled from '@emotion/styled';

const Container = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 10px;
  height: inherit;
`;

export { Container };
